module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc6-2bd96db524972174b7f185f2288fe789.jpg";